import { useState } from 'react';

const useCustomHook = () => {
  const DEFAULT_GRANT_DATA_TYPE = 'cellphoneNumber';
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [grantUserDataType, setGrantUserDataType] = useState(DEFAULT_GRANT_DATA_TYPE);
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [captchaId, setCaptchaId] = useState(null);
  const [enteredCaptcha, setEnteredCaptcha] = useState('');
  const [captchaImg, setCaptchaImg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [foundUser, setFoundUser] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [amount, setAmount] = useState(null);
  const [isTransferLoading, setIsTransferLoading] = useState(false);
  return {
    isPageLoading,
    setIsPageLoading,
    grantUserDataType,
    setGrantUserDataType,
    captchaLoading,
    setCaptchaLoading,
    captchaId,
    setCaptchaId,
    enteredCaptcha,
    setEnteredCaptcha,
    captchaImg,
    setCaptchaImg,
    isLoading,
    setIsLoading,
    foundUser,
    setFoundUser,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    currentUserId,
    setCurrentUserId,
    amount,
    setAmount,
    isTransferLoading,
    setIsTransferLoading,
  };
};

export default useCustomHook;
